import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  public baseurl: string;
  temp: string;
  headers = new Headers();


  constructor(private __http: HttpClient) {
    this.baseurl = environment.url_server;
    this.headers.set("Content-Type", "multipart/form-data");
    this.headers.set("Authorization", 'Bearer '+ JSON.parse(localStorage.getItem('access_token')));
  }

  post_auth_image_user_id(data, id):Observable<any> {
    this.temp = this.baseurl + 'auth/image/user/'+id ;
    return this.__http.post( this.temp, data )
    .pipe( retry(1),
      catchError(this.errorHandl)
    );
  }

  get_problemTypes(): Observable<any> {
    this.temp = this.baseurl + "problemTypes";
    return this.__http.get( this.temp)
      .pipe(retry(1),
        catchError(this.errorHandl)
      )
  }

  post_contactSupport(data):Observable<any> {
    this.temp = this.baseurl + 'contactSupport' ;
    return this.__http.post( this.temp, data )
    .pipe( retry(1),
      catchError(this.errorHandl)
    );
  }

  post_password_change(data):Observable<any> {
    this.temp = this.baseurl + 'password/change' ;
    return this.__http.post( this.temp, data )
    .pipe( retry(1),
      catchError(this.errorHandl)
    );
  }



  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;// Get client-side error
    } else {
      errorMessage = error; // Get server-side error
    }
    return throwError(errorMessage);
  }
}
